import { breakpoints } from "../../../../constants/breakpoints/breakpoints.js";
import "@mui/material/styles";
import "../../../../themes/shadows/shadows.js";
import "../../../../themes/typography/typography.js";
import "@mui/material";
import "../../../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../../../themes/typography/utils/typographyVariants/typographyVariants.js";
const DEFAULT_PROFILE_IMG = "https://ucarecdn.com/361407e2-f7a2-44ec-844b-10991d7b4f3a/";
const FLAG_ICON_CDN_LINK = "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.5.0/flags/1x1/";
const DEFAULT_SLIDER_CONFIG = {
  arrows: true,
  variableWidth: true,
  adaptiveHeight: true,
  infinite: true,
  speed: 1e3,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: breakpoints.values.lg,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows: false
      }
    },
    {
      breakpoint: breakpoints.values.md,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false
      }
    }
  ]
};
export {
  DEFAULT_PROFILE_IMG,
  DEFAULT_SLIDER_CONFIG,
  FLAG_ICON_CDN_LINK
};
